import * as React from 'react';
import * as shortid from 'shortid';
import {
  SelectionControlProps,
  SelectionControlState,
  SelectionControlWrapperProps,
  SelectionControlInputProps,
  SelectionControlStateProps,
  SelectionControlPropsGetters
} from './types';

export default class SelectionControl extends React.Component<SelectionControlProps, SelectionControlState> {
  private _uid = shortid.generate();

  constructor(props: SelectionControlProps) {
    super(props);
    this.state = {
      checked: Boolean(this._isControlled ? props.checked : props.defaultChecked),
      hovered: false,
      focused: false
    };
  }

  public componentWillReceiveProps(nextProps: SelectionControlProps) {
    if (nextProps.checked !== this.props.checked) {
      this.setState({checked: Boolean(nextProps.checked)});
    }
  }

  public render() {
    return this.props.children(this._propsGetters);
  }

  private get _id() {
    return this.props.id || this._uid;
  }

  private get _propsGetters(): SelectionControlPropsGetters {
    return {
      getStateProps: this._getStateProps,
      getWrapperProps: this._getWrapperProps,
      getInputProps: this._getInputProps
    };
  }

  private _getWrapperProps = (): SelectionControlWrapperProps => {
    return {
      htmlFor: this._id,
      className: this.props.className,
      onMouseEnter: this._handleMouseEnter,
      onMouseLeave: this._handleMouseLeave
    };
  };

  private _getInputProps = (): SelectionControlInputProps => {
    const {inputRef, inputType, defaultChecked, value, disabled} = this.props;
    const {checked} = this.state;

    return {
      id: this._id,
      ref: inputRef,
      type: inputType,
      onChange: this._handleChange,
      onFocus: this._handleFocus,
      onBlur: this._handleBlur,
      checked: this._isControlled ? checked : undefined,
      defaultChecked,
      value,
      disabled,
      ...(inputType === 'checkbox' ? {'aria-checked': checked} : {})
    };
  };

  private _getStateProps = (): SelectionControlStateProps => {
    return {...this.state, disabled: Boolean(this.props.disabled)};
  };

  private _handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!this._isControlled) {
      this.setState({checked: event.target.checked});
    }
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(event);
    }
  };

  private _handleFocus = () => {
    this.setState({focused: true});
  };

  private _handleBlur = () => {
    this.setState({focused: false});
  };

  private _handleMouseEnter = () => {
    this.setState({hovered: true});
  };

  private _handleMouseLeave = () => {
    this.setState({hovered: false});
  };

  private get _isControlled() {
    return this.props.checked !== undefined;
  }
}



// WEBPACK FOOTER //
// ./src/components/SelectionControl/SelectionControl.tsx